import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react'

import PostSingle from './PostSingle'
import { getCursor, getNextPost } from '../../utils'
import { Advertisement } from '../advertisement/Advertisement'
import { ObserverWrapper } from './ObserverWrapper'
import { LoadingSpinner } from '../loadingSpinner/LoadingSpinner'

const maximumPosts = 5 // max posts to fetch

const NextPosts = ({ post }) => {
  const [list, setList] = useState([])
  const [loadMore, setLoadMore] = useState(false)
  const [hasMore, setHasMore] = useState(list.length < maximumPosts)
  const [cursor, setCursor] = useState()

  const loadRef = useRef(null)
  const [categorySlug, setCategorySlug] = useState(
    post.categories?.cats[0]?.slug,
  )
  const authorId = post.author?.details?.id

  const handleObserver = entities => {
    entities.forEach(entity => {
      if (entity.isIntersecting) setLoadMore(true)
    })
  }

  const categoryId = post?.categories?.cats?.[0]?.id;

  const adplacement =
    categoryId === 'dGVybToxMjk4NQ=='
      ? 'betong'
      : categoryId === 'dGVybToy' 
      ? 'arkitekt'
      : null; 

  useEffect(() => {
    ;(async () => {
      if (!cursor && !loadMore) setCursor(await getCursor(post.slug))
    })()
  }, [cursor, loadMore, post])

  useEffect(() => {
    let options = {
      root: null,
      rootMargin: '100px',
      threshold: 1.0,
    }

    const observer = new IntersectionObserver(handleObserver, options)

    if (loadRef.current) {
      observer.observe(loadRef.current)
    }

    return () => observer.disconnect()
  }, [list])

  const handleDataUpdate = useCallback(
    data => {
      if (!data) {
        setCategorySlug('')
        setCursor('')
      }

      if (list.length >= maximumPosts - 1) setHasMore(false)
    },
    [list],
  )

  useEffect(() => {
    if (loadMore && hasMore) {
      ;(async () => {
        const useAuthorID = categorySlug === 'bloggar' ? authorId : ''
        const postsIds = [post.id, ...list.map(e => e.id)]
        let data = await getNextPost(
          cursor,
          categorySlug,
          useAuthorID,
          postsIds,
        )

        if (data) {
          setCursor(data.cursor)
          setList(list => [...list, data.post])
          setLoadMore(false)
        }

        handleDataUpdate(data)
      })()
    }
  }, [
    loadMore,
    hasMore,
    cursor,
    categorySlug,
    authorId,
    list,
    post,
    handleDataUpdate,
  ])

  return (
    <Fragment>
      <ObserverWrapper uri={post?.uri} />

      {list.map((post, idx) => {
        return (
          <ObserverWrapper key={idx} uri={post?.uri}>
            <PostSingle post={post} />
            {hasMore && (
              <div
                style={{
                  height: '126px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  overflow: 'hidden',
                  margin: '8rem 0 8rem calc((-100vw + 100%) / 2)',
                  width: '100vw',
                }}
              >
                <Advertisement size="large" borderRadius="0" adplacement={adplacement}/>
              </div>
            )}
          </ObserverWrapper>
        )
      })}
      <div ref={loadRef} style={{ margin: '0 auto 4rem', textAlign: 'center' }}>
        {hasMore ? <LoadingSpinner /> : null}
      </div>
    </Fragment>
  )
}

export default NextPosts
